import { NUTRITION_OVERRIDE_TOGGLE_OPEN, NUTRITION_OVERRIDE_CLOSE } from '../constants';

const initialState = {
  isOpen: false,
  recipeId: null,
};

export default function nutritionOverrideReducer(state = initialState, action) {
  switch (action.type) {
    case NUTRITION_OVERRIDE_TOGGLE_OPEN: {
      const nextRecipeId = action.payload && action.payload.recipeId;
      // If a different recipe is being targeted, open with that recipeId.
      if (nextRecipeId && nextRecipeId !== state.recipeId) {
        return { isOpen: true, recipeId: nextRecipeId };
      }
      // Same recipe → toggle.
      if (state.isOpen) {
        return { isOpen: false, recipeId: null };
      }
      return { isOpen: true, recipeId: nextRecipeId || state.recipeId };
    }
    case NUTRITION_OVERRIDE_CLOSE:
      return { isOpen: false, recipeId: null };
    default:
      return state;
  }
}
